// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-change-log-summary-listing .changeLogSummaryContainer {
  padding-bottom: 24px;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryHeader {
  padding: 15px;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryHeader .title {
  font-weight: 600;
}
app-change-log-summary-listing .changeLogSummaryContainer .dateTimeContainer {
  flex: 0 1 190px;
  padding-left: 10px;
}
app-change-log-summary-listing .changeLogSummaryContainer .summaryContainer {
  flex: 0 1 580px;
  padding-left: 10px;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryHeaderContainer {
  padding-top: 12px;
  padding-bottom: 12px;
  margin-bottom: 12px;
  background: whitesmoke;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryHeaderContainer .headerContainer {
  font-weight: 400;
  color: #5484ff;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow {
  padding-bottom: 16px;
  padding-top: 16px;
  border-bottom: 1px solid #5484ff;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerHeader {
  border-right: 1px solid #5484ff;
  border-left: 1px solid #5484ff;
  border-top: 1px solid #5484ff;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerHeader .a {
  height: 68px;
  flex: 0 0 190px;
  color: #5484ff;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerHeader .category {
  padding-top: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #5484ff;
  border-left: 1px solid #5484ff;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerHeader .howManyContainer {
  padding-left: 20px;
  flex: 0 0 90px;
  font-weight: bold;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerHeader .howLongContainer {
  flex: 0 0 90px;
  font-weight: bold;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerHeader .decisionContainer {
  flex: 0 0 70px;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerRow {
  height: 80px;
  border: 1px solid #5484ff;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerRow .crimeTitle {
  flex: 0 0 190px;
  font-weight: bold;
  border-right: 1px solid #5484ff;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerRow .howManyContainer {
  padding-left: 20px;
  flex: 0 0 90px;
  border-right: 1px solid #5484ff;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerRow .howLongContainer {
  border-right: 1px solid #5484ff;
  flex: 0 0 90px;
}
app-change-log-summary-listing .changeLogSummaryContainer .changeLogSummaryRow .summaryDetailContainerRow .decisionContainer {
  border-right: 1px solid #5484ff;
  flex: 0 0 70px;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/Components/change-log/change-log-summary-listing/change-log-summary-listing.component.less"],"names":[],"mappings":"AAAA;EAII,oBAAA;AAFJ;AAFA;EAOM,aAAA;AAFN;AALA;EAUQ,gBAAA;AAFR;AARA;EAeM,eAAA;EACA,kBAAA;AAJN;AAZA;EAoBM,eAAA;EACA,kBAAA;AALN;AAhBA;EA0BM,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;AAPN;AAtBA;EAgCQ,gBAAA;EACA,cAAA;AAPR;AA1BA;EAuCM,oBAAA;EACA,iBAAA;EACA,gCAAA;AAVN;AA/BA;EAqDQ,+BAAA;EACA,8BAAA;EACA,6BAAA;AAnBR;AApCA;EA6DU,YAAA;EAEA,eAAA;EACA,cAAA;AAvBV;AAzCA;EAoEU,iBAAA;EACA,oBAAA;EACA,gCAAA;EACA,8BAAA;AAxBV;AA/CA;EA8EU,kBAAA;EACA,cAAA;EACA,iBAAA;AA5BV;AApDA;EAoFU,cAAA;EACA,iBAAA;AA7BV;AAxDA;EAyFU,cAAA;AA9BV;AA3DA;EAkGQ,YAAA;EACA,yBAAA;AApCR;AA/DA;EAsGU,eAAA;EACA,iBAAA;EACA,+BAAA;AApCV;AApEA;EA4GU,kBAAA;EACA,cAAA;EACA,+BAAA;AArCV;AAzEA;EAkHU,+BAAA;EACA,cAAA;AAtCV;AA7EA;EAuHU,+BAAA;EACA,cAAA;AAvCV","sourcesContent":["app-change-log-summary-listing {\n\n  .changeLogSummaryContainer {\n\n    padding-bottom: 24px;\n\n    .changeLogSummaryHeader {\n      padding: 15px;\n\n      .title {\n        font-weight: 600;\n      }\n    }\n\n    .dateTimeContainer {\n      flex: 0 1 190px;\n      padding-left: 10px;\n    }\n\n    .summaryContainer {\n      flex: 0 1 580px;\n      padding-left: 10px;\n    }\n\n\n    .changeLogSummaryHeaderContainer {\n      padding-top: 12px;\n      padding-bottom: 12px;\n      margin-bottom: 12px;\n      background: whitesmoke;\n\n      .headerContainer {\n        font-weight: 400;\n        color: #5484ff;\n      }\n    }\n\n    .changeLogSummaryRow {\n\n      padding-bottom: 16px;\n      padding-top: 16px;\n      border-bottom: 1px solid #5484ff;\n\n      .dateTimeContainer {\n\n      }\n\n      .summaryContainer {\n\n      }\n\n\n      .summaryDetailContainerHeader {\n        border-right: 1px solid #5484ff;\n        border-left: 1px solid #5484ff;\n        border-top: 1px solid #5484ff;\n\n        .a {\n\n          //padding-top: 34px;\n          //padding-bottom: 34px;\n          height: 68px;\n          // border: 1px solid #5484ff;\n          flex: 0 0 190px;\n          color: #5484ff;\n        }\n\n        .category {\n          padding-top: 14px;\n          padding-bottom: 14px;\n          border-bottom: 1px solid #5484ff;\n          border-left: 1px solid #5484ff;\n          //border-bottom: 1px solid #5484ff;\n          //border-top: 1px solid #5484ff;\n        }\n\n\n        .howManyContainer {\n          padding-left: 20px;\n          flex: 0 0 90px;\n          font-weight: bold;\n        }\n\n        .howLongContainer {\n          flex: 0 0 90px;\n          font-weight: bold;\n        }\n\n        .decisionContainer {\n          flex: 0 0 70px;\n\n        }\n      }\n\n\n      // Row data\n      .summaryDetailContainerRow {\n        // padding-bottom: 20px;\n        height: 80px;\n        border: 1px solid #5484ff;\n\n        .crimeTitle {\n          flex: 0 0 190px;\n          font-weight: bold;\n          border-right: 1px solid #5484ff;\n        }\n\n        .howManyContainer {\n          padding-left: 20px;\n          flex: 0 0 90px;\n          border-right: 1px solid #5484ff;\n        }\n\n        .howLongContainer {\n          border-right: 1px solid #5484ff;\n          flex: 0 0 90px;\n        }\n\n        .decisionContainer {\n          border-right: 1px solid #5484ff;\n          flex: 0 0 70px;\n\n        }\n\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
